import React, { useState } from 'react';
import { ReactComponent as Close } from '../../assets/svg/Close.svg';
import { ReactComponent as AngleUp } from '../../assets/svg/AngleUp.svg';

function CategoriesDropDown({
	label = 'Categories',
	list,
	register,
	registerField,
	errors,
	selectedValue,
	setSelectedValue,
}: {
	label: string;
	list: any;
	register: any;
	registerField: string;
	errors: any;
	selectedValue: any;
	setSelectedValue: any;
}) {
	const [showValues, setShowValues] = useState(false);
	return (
		<div className='flex flex-col w-full'>
			<label className='text-[16px] leading-5 font-semibold text-primaryViolet  '>{label}</label>
			<div className='bg-white border border-primaryViolet rounded-[4px]  w-full px-3 cursor-pointer relative mt-2'>
				<div className=' h-[48px] flex flex-row items-center justify-between  ' onClick={() => setShowValues((prev) => !prev)} {...register(registerField, { required: true })}>
					<p className='flex-1 text-[16px] leading-5 text-darkenPurple ellipsis'>{selectedValue}</p>
					{!!selectedValue && selectedValue !== 'Select' && (
						<div
							className='mr-2 cursor-pointer'
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								setSelectedValue(null);
								setShowValues(false);
							}}
							title='Remove item'
						>
							<Close />
						</div>
					)}
					<div className={`${showValues ? 'rotate-180' : 'rotate-0'} transition`}>
						<AngleUp style={{ color: '#5E639B' }} />
					</div>
				</div>
				{showValues && (
					<div
						className='absolute top-[52px]  left-0 bg-white z-10 w-[calc(100%+2px)] -ml-[1px] shadow-md  border border-primaryViolet rounded-[4px] pr-[2px]'
						onMouseLeave={() => setShowValues(false)}
					>
						<div className='w-full max-h-[160px] overflow-auto orange-tiny-scroll rounded-md'>
							{list?.length === 0 && (
								<div
									className='h-[48px] px-3 flex flex-row items-center bg-white hover:bg-greyLight cursor-pointer '
									onClick={() => {
										setSelectedValue(null);
										setShowValues(false);
									}}
								>
									<p className='text-[16px] leading-5 text-black700 '>No items</p>
								</div>
							)}
							{list?.map((item: any, index: number) => {
								return (
									<div
										className='h-[48px] px-3 flex flex-row items-center bg-white hover:bg-greyLight cursor-pointer '
										onClick={() => {
											setSelectedValue(item);
											setShowValues(false);
										}}
										key={index}
									>
										<p className='text-[16px] leading-5 text-darkenPurple '>{item?.name}</p>
									</div>
								);
							})}
						</div>
					</div>
				)}
			</div>
			<span className='text-redError text-[12px] leading-5 h-5 '>{errors === 'required' ? 'Field is required!' : ''}</span>
		</div>
	);
}

export default CategoriesDropDown;
